import BranchDialog from 'components/BranchesView/BranchExplorer/BranchDialog';
import StyledButton from 'components/general/StyledButton';
import { IMissionVersion } from 'components/general/types';
import { CHECKOUT_COMMIT_CUTOFF } from 'config';
import { useEntityDialogControl } from 'hooks';
import moment from 'moment-timezone';
import { ICommit } from '../useGitHistory';
import useStyles from './styles';

interface IProps {
  branch: IMissionVersion;
  commit: ICommit;
  passedMaxHeight: boolean;
  closeHistoryDialog: () => void;
}

const CommitRow = (props: IProps) => {
  const { branch, commit, passedMaxHeight, closeHistoryDialog } = props;
  const { classes } = useStyles({ passedMaxHeight });
  const dialogControl = useEntityDialogControl<IMissionVersion>();

  const onClick = () => dialogControl.openDialogForExisting(branch, 'branch');

  const commitDate = moment(commit.time);
  const canCheckout = commitDate.isAfter(moment(CHECKOUT_COMMIT_CUTOFF));

  return (
    <div className={classes.commitContainer} key={JSON.stringify(commit)}>
      <div>
        <strong>{commit.message}</strong>
        <div>
          {commit.author} - {commitDate.fromNow()}
        </div>
      </div>

      {canCheckout && (
        <>
          <StyledButton
            style={{ minWidth: 'fit-content' }}
            framed
            onClick={onClick}
            tooltip="Make a new branch from this commit"
          >
            Branch
          </StyledButton>

          <BranchDialog
            dialogControl={dialogControl}
            commitHexsha={commit.hexsha}
            extendSuccessCallback={closeHistoryDialog}
          />
        </>
      )}
    </div>
  );
};

export default CommitRow;
